export const WIDGET_ID = "widget-volume-share";

export const SHARE_OF_VOLUME_CHANGE_DATA_POINTS_MIN_COUNT = 2 as const;
